import { useMemo } from "react";
import { useMst } from "../../../stores/main";
import {
  buildTimelineLayerTree,
  flattenLayers,
  type TimelineLayerInfo,
  type TimelineData,
} from "../utils/layerHierarchy";

export interface UseTimelineLayersResult extends TimelineData {
  layers: TimelineLayerInfo[];
}

/**
 * Hook that builds the timeline layer tree from jsonFile.
 * Note: This returns the hierarchical layers, not flattened.
 * Flattening should be done in the observer component to ensure MobX reactivity.
 */
export function useTimelineLayers(): UseTimelineLayersResult {
  const {
    playerStore: { jsonFile },
  } = useMst();

  const timelineData = useMemo(() => {
    return buildTimelineLayerTree(jsonFile);
  }, [jsonFile]);

  return timelineData;
}

export { flattenLayers };
